import { render } from "./CurList.vue?vue&type=template&id=437bc10a&style=height%3A%20100%25%3Bposition%3A%20relative%3B"
import script from "./CurList.vue?vue&type=script&lang=js"
export * from "./CurList.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20230426.133748/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__